module.exports = __webpack_public_path__ + "quotation_gray_bottom.26d827b5.svg";